import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';

export default function Inicio() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/posts')
      .then((res) => {
        setPosts(res.data.slice(0, 3));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section - Más minimalista y elegante */}
      <section className="relative h-[90vh] flex items-center justify-center bg-slate-900 overflow-hidden">
        {/* Imagen de fondo con overlay sutil en lugar de gradiente sólido */}
        <div className="absolute inset-0 opacity-40">
          <img 
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=2000" 
            className="w-full h-full object-cover"
            alt="Hero background"
          />
        </div>
        
        <div className="relative z-10 max-w-5xl mx-auto text-center px-6">
          <span className="inline-block text-blue-400 tracking-[0.2em] uppercase text-sm font-semibold mb-4">
            Inmobiliaria Boutique
          </span>
          <h1 className="text-5xl md:text-7xl font-light mb-8 text-white leading-tight">
            El arte de encontrar <br />
            <span className="font-serif italic text-blue-200">tu lugar</span> en el mundo
          </h1>
          <div className="flex flex-col sm:flex-row gap-6 justify-center mt-12">
            <Link 
              to="/propiedades" 
              className="bg-white text-slate-900 hover:bg-blue-50 px-10 py-4 text-sm font-bold uppercase tracking-widest transition-all"
            >
              Explorar Catálogo
            </Link>
            <Link 
              to="/contacto" 
              className="border border-white/30 text-white hover:bg-white/10 px-10 py-4 text-sm font-bold uppercase tracking-widest backdrop-blur-sm transition-all"
            >
              Hablar con un experto
            </Link>
          </div>
        </div>
      </section>

      {/* Stats / Value Prop - Diseño más limpio */}
      <section className="py-24 px-6 border-b border-gray-100">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-16">
          <div className="space-y-4">
            <h3 className="text-3xl font-light">20+ años de <br/><span className="font-bold">Excelencia</span></h3>
            <p className="text-slate-500 leading-relaxed">Curamos cada propiedad bajo estándares de alta calidad y ubicación privilegiada.</p>
          </div>
          <div className="space-y-4">
            <h3 className="text-3xl font-light">Atención <br/><span className="font-bold">Personalizada</span></h3>
            <p className="text-slate-500 leading-relaxed">No somos una plataforma masiva; somos tus aliados en una de las decisiones más importantes.</p>
          </div>
          <div className="space-y-4">
            <h3 className="text-3xl font-light">Gestión <br/><span className="font-bold">Integral</span></h3>
            <p className="text-slate-500 leading-relaxed">Desde la primera visita hasta la firma de escrituras, nos encargamos de todo el proceso legal.</p>
          </div>
        </div>
      </section>

      {/* Blog Section - Tarjetas tipo Revista */}
      <section className="py-24 bg-gray-50/50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-end mb-16">
            <div>
              <h2 className="text-4xl font-light mb-2">Editoriales</h2>
              <p className="text-slate-500">Tendencias y guías del mercado inmobiliario.</p>
            </div>
            <Link to="/blog" className="hidden md:block text-sm font-bold border-b-2 border-slate-900 pb-1 hover:text-blue-600 hover:border-blue-600 transition-all">
              VER TODAS LAS NOTAS
            </Link>
          </div>

          {loading ? (
            <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-slate-300 border-t-slate-900 animate-spin rounded-full"></div></div>
          ) : (
            <div className="grid md:grid-cols-3 gap-10">
              {posts.map((post) => (
                <article key={post.id} className="group cursor-pointer">
                  <div className="overflow-hidden bg-gray-200 aspect-[4/5] mb-6">
                    <div className="w-full h-full bg-slate-300 group-hover:scale-105 transition-transform duration-700 flex items-center justify-center text-slate-400">
                      {/* Aquí iría la imagen real del post */}
                      <span className="text-xs uppercase tracking-widest">Property Preview</span>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <span className="text-[10px] uppercase tracking-[0.2em] text-blue-600 font-bold">Inversión • {new Date(post.created_at).getFullYear()}</span>
                    <h3 className="text-xl font-medium leading-snug group-hover:text-blue-700 transition-colors">
                      <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                    </h3>
                    <p className="text-slate-500 line-clamp-2 text-sm">Descubre cómo esta propiedad redefine el concepto de modernidad y confort...</p>
                    <Link to={`/blog/${post.slug}`} className="inline-block pt-2 text-xs font-bold uppercase tracking-tighter group-hover:translate-x-2 transition-transform">
                      Leer Artículo —
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section - Minimalista y potente */}
      <section className="py-32 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-light mb-8">¿Empezamos el viaje?</h2>
          <p className="text-lg text-slate-500 mb-12 italic font-serif">
            "La casa de tus sueños no se busca, se encuentra con los asesores correctos."
          </p>
          <Link 
            to="/contacto" 
            className="inline-block bg-slate-900 text-white px-12 py-5 text-sm font-bold uppercase tracking-widest hover:bg-blue-900 transition-colors"
          >
            Agendar Consulta Privada
          </Link>
        </div>
      </section>
    </div>
  );
}